import { cn } from "../../../lib/utils";
import type { AuditEventType } from "../../../models/audit/auditEvent";
import { ICON_BY_EVENT_TYPE } from "./eventIcons";

interface AuditEventIconProps {
  eventType: AuditEventType;
  className?: string;
}

/**
 * Muted circular icon chip for the single-column audit feeds (the workspace
 * table and the attribute-test-result panel). The drawer's timeline rail uses
 * `AuditEventGlyph` instead, which sits on a hairline rather than filling.
 */
export function AuditEventIcon({ eventType, className }: AuditEventIconProps) {
  const Icon = ICON_BY_EVENT_TYPE[eventType];

  return (
    <div
      className={cn(
        "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-stone-200 text-stone-600",
        className,
      )}
    >
      <Icon className="h-3.5 w-3.5" />
    </div>
  );
}
